import React, { useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Loader from "./components/Loader";
import BackToTop from "./components/BackToTop";
import SEO from "./components/SEO";
import Nav from "./components/Nav";
import Rail from "./components/Rail";
import Hero from "./components/Hero";
import Positioning from "./components/Positioning";
import Marquee from "./components/Marquee";
import Ecosystem from "./components/Ecosystem";
import WebsiteSection from "./components/WebsiteSection";
import ContentSection from "./components/ContentSection";
import Performance from "./components/Performance";
import Approach from "./components/Approach";
import Differentiator from "./components/Differentiator";
import About from "./components/About";
import BigCTA from "./components/BigCTA";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ServicesPage from "./pages/ServicesPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import "./pages/services.css";
import "./pages/about.css";
import "./pages/contact.css";
import "./pages/blog.css";

/* ── Scroll to top on every route change ── */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

/* ─────────────────────────────────────────
   HOME PAGE
───────────────────────────────────────── */
function HomePage() {
  const homeSchema = [
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": "https://ovarddigital.com/#webpage",
      "url": "https://ovarddigital.com/",
      "name": "OVARD Digital — Digital Marketing & Brand Growth Agency India",
      "isPartOf": { "@id": "https://ovarddigital.com/#website" },
      "about": { "@id": "https://ovarddigital.com/#organization" },
      "description": "OVARD Digital is a full-service digital marketing and brand growth agency in Mysore, India. Brand identity, websites, content creation, performance marketing and AI systems — built around your business.",
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://ovarddigital.com/" }
        ]
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is OVARD Digital?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "OVARD Digital is a full-service digital marketing and brand growth agency based in Mysore, India. We build brands, websites, content and marketing systems for businesses across India."
          }
        },
        {
          "@type": "Question",
          "name": "What services does OVARD Digital offer?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "OVARD Digital offers brand identity, website development, e-commerce, content creation, production and shoots, social media management, performance marketing (Meta Ads, Google Ads), SEO, marketing strategy, automation and AI systems."
          }
        },
        {
          "@type": "Question",
          "name": "Where is OVARD Digital located?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "OVARD Digital is based in Mysore, Karnataka, India and works with businesses across India."
          }
        },
        {
          "@type": "Question",
          "name": "How can I contact OVARD Digital?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can reach OVARD Digital by email at ovarddigital@gmail.com, by WhatsApp or phone at +91 7975034116, or through the contact form at ovarddigital.com/contact."
          }
        }
      ]
    }
  ];

  return (
    <>
      <SEO
        title="OVARD Digital — Digital Marketing & Brand Growth Agency India"
        description="OVARD Digital is a full-service digital marketing and brand growth agency in Mysore, India. Brand identity, websites, content, Meta Ads, Google Ads, SEO and AI systems — built around your business."
        canonical="/"
        schema={homeSchema}
        isHomepage={true}
      />
      <div className="noise" />
      <Nav />
      <Rail />
      <main>
        <Hero />
        <Positioning />
        <Marquee />
        <Ecosystem />
        <WebsiteSection />
        <ContentSection />
        <Performance />
        <Marquee />
        <Approach />
        <Differentiator />
        <About />
        <BigCTA />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

/* ─────────────────────────────────────────
   APP ROOT
───────────────────────────────────────── */
export default function App() {
  // Only show loader on first visit — never on route changes
  const [loaded, setLoaded] = useState(() => {
    return sessionStorage.getItem("ovard_loaded") === "1";
  });

  const handleLoaded = () => {
    sessionStorage.setItem("ovard_loaded", "1");
    setLoaded(true);
  };

  return (
    <BrowserRouter>
      {!loaded && <Loader onDone={handleLoaded} />}
      <div style={{ opacity: loaded ? 1 : 0, transition: "opacity 0.3s ease" }}>
        <ScrollToTop />
        <BackToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:id" element={<ServiceDetailPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:id" element={<BlogPostPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}
